var collapsible_list_component_rtlignore_default = {
  "ltr": "X50vn",
  "rtl": "lqvBH",
  "iconContainer": "OH-sp",
  "icon": "_9xK5p",
  "isExpanded": "ACId1",
  "listDimensions": "mVl-o"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
